// MainQuotePage.js
import React, { useEffect, useState } from 'react';
import { useQuoteOfferContext } from '../../../Context/Cache/QuoteOffers/QuoteOfferContext';
import { BsSortDownAlt, BsSortUp } from "react-icons/bs";
import Popup from './Popup';
import QuoteDetailPage from './QuoteDetailPage';
import { SecondaryLoadingScreen } from '../../LoadingScreen';
import { TiArrowForwardOutline } from "react-icons/ti";
 
const MainQuotePage = () => {
  const { quotes, loading, fetchQuotes } = useQuoteOfferContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedQuoteId, setSelectedQuoteId] = useState(null);
  const [selectedQuoteType, setSelectedQuoteType] = useState(null);
  const [selectedQuoteStatus, setSelectedQuoteStatus] = useState(null)
  const [quoteNumber, setQuoteNumber] = useState(null)
  const [quoteStatus, setQuoteStatus] = useState([])
  const [sortOrder, setSortOrder] = useState(localStorage.getItem('sortOrder') || 'desc');
  const [sortedQuotes, setSortedQuotes] = useState(quotes || []);
  // Function to toggle sort order
  useEffect(() => {
    // Get the saved sort order from localStorage on component mount
    const savedSortOrder = localStorage.getItem('sortOrder');
    if (savedSortOrder) {
      setSortOrder(savedSortOrder);
    }
  }, []);
 
  const handleOpenModal = (quoteId, quoteType, quoteStatus, quoteNumber) => {
    setSelectedQuoteId(quoteId);
    setSelectedQuoteType(quoteType);
    setSelectedQuoteStatus(quoteStatus)
    setQuoteNumber(quoteNumber)
    setModalOpen(true);
  };
 
  const handleCloseModal = async () => {
    await fetchQuotes()
    setModalOpen(false);
    setSelectedQuoteId(null);
  };
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  };
 
  const getStatusText = (status) => {
    switch (status) {
      case 219640000:
        return { text: "Under review by Sales person", color: "red" };
      case 219640001:
        return { text: "Under review by customer", color: "blue" };
      case 219640002:
        return { text: "Negotiation Completed", color: "green" };
      default:
        return { text: "Unknown Status", color: "gray" };
    }
  };
 
  useEffect(() => {
    if (Array.isArray(quotes)) { // Check if quotes is an array
      const sortedData = [...quotes].sort((a, b) => {
        const dateA = new Date(a.createdon);
        const dateB = new Date(b.createdon);
        return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
      setSortedQuotes(sortedData);
    }
  }, [sortOrder, quotes]);
  
 
  // Toggle and sort quotes based on createdon
  const toggleSort = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
    localStorage.setItem("sortOrder", newSortOrder);
  };
 
  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
 
  // Funtion to formatCurrency
  function formatNumber(number) {
    if (isNaN(number) || number === null || number === undefined) {
      number = 0;
    }
    const formattedNumber = Number(number).toFixed(2);
    return formatNumberWithCommas(formattedNumber);
  }
 
  return (
    <div>
      {
        loading ? (
 
          <div className='flex justify-center items-center'>
            <SecondaryLoadingScreen />
          </div>
        ) : (
          <div className='flex flex-col gap-2'>
            <div className='flex justify-between items-center'>
              <span className="lineheight18 font-bold font-weight-bold">
                Recent Offer
              </span>
              <span>
                <button onClick={toggleSort} className="flex items-center text-sm">
                  {sortOrder === "asc" ? (
                    <>
                      <BsSortDownAlt /> Oldest to Newest
                    </>
                  ) : (
                    <>
                      <BsSortUp /> Newest to Oldest
                    </>
                  )}
                </button>
 
              </span>
            </div>
            <div>
              {/* {Array.isArray(quotes) && quotes.length > 0 ? (
                quotes.map((quote) => ( */}
                {Array.isArray(sortedQuotes) && sortedQuotes.length > 0 ? (
                  sortedQuotes.map((quote) => (
                  <div key={quote.quoteid} className="accordion2-item bg-white" id={quote.quoteid} onClick={() => handleOpenModal(quote.quoteid, quote.nyc_quotetype, quote.nyc_negotiationstages, quote.quotenumber)}>
                    <div className="accordion2-header ">
                      <div className="w-full flex justify-between items-center">
                        <div className='w-full flex gap-1 items-center'>
                          <TiArrowForwardOutline className='text-lg' />
                          <div>
                            <p className="accordion2-title">
                              Offer ID: <span className="text-blue-600 hover:text-blue-500 underline">{quote.quotenumber}</span>
                            </p>
                            <span>
                              <span className='font-bold'>Account Name: </span>
                              <span>{quote.nyc_account_name}</span>
                            </span>
                          </div>
                        </div>
                        <div className='w-full flex justify-center items-center' style={{ color: getStatusText(quote.nyc_negotiationstages).color }}>
                          {getStatusText(quote.nyc_negotiationstages).text}
                        </div>
                        <div className="w-full flex flex-col items-end">
                          <span className="flex gap-1">
                            <p>Offer Date :</p>
                            <p>{formatDate(quote.createdon)}</p>
                          </span>
                          <span className="flex font-bold gap-1">
                            <p>Grand Total :</p>
                            {/* <p>{quote.nyc_totalamount}</p> */}
                            <p>$ {formatNumber(parseFloat(quote.nyc_totalamount).toFixed(2))}</p>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Offer available</p>
              )}
            </div>
            {/* </tbody>
      </table> */}
 
            {/* Modal to show quote details */}
 
            <Popup isOpen={isModalOpen} onClose={handleCloseModal}>
              {selectedQuoteId && <QuoteDetailPage quoteId={selectedQuoteId} quoteType={selectedQuoteType} quoteStatus={selectedQuoteStatus} quoteNumber={quoteNumber} onClose={handleCloseModal} />}
            </Popup>
          </div>
        )
      }
    </div>
  );
};
 
export default MainQuotePage;